/**
 * Copyright (c) [2015-2019] SUSE Linux
 *
 * This software may be modified and distributed under the terms
 * of the MIT license.  See the LICENSE.txt file for details.
 */

import { actionCreators as actions } from '../state/ducks';
import DOMPurify from 'dompurify';

export const createRoomEventsHandler = (dispatchFn) => ({event, payload}) => {
  const handlers = {

    createFeed: (data) => {
      dispatchFn(actions.participants.addParticipant(data));
      dispatchFn(actions.participants.autoSetFocus());
      if (!data.local) {
        dispatchFn(actions.messages.add('newRemoteFeed', data));
      }
    },
    updateStream: (data) => {
      dispatchFn(actions.participants.setStream(data.feedId, data.stream));
    },
    updateFeed: (data) => {
      dispatchFn(actions.participants.updateStatus(data.id, data));
      dispatchFn(actions.participants.autoSetFocus());
    },
    createChatMsg: (data) => {
      const sanitized = DOMPurify.sanitize(data.text);
      if (sanitized !== '') {
        dispatchFn(actions.messages.addChatMsg(data.feedId, sanitized));
      }
    },
    speakDetection: ({ speaking }) => {
      dispatchFn(actions.participants.localSpeak(speaking));
    },
    muteFeed: (data) => {
      dispatchFn(actions.participants.requestMute(data));
    },
    destroyParticipant: ({ id }) => {
      dispatchFn(actions.participants.removeParticipant(id));
      dispatchFn(actions.participants.autoSetFocus());
    },
    reportError: ({ error }) => {
      dispatchFn({ type: 'error' });
    },

    // 通话相关事件处理
    incomingCall: (data) => {
      // data包含 { callId, callerId, roomId, timestamp }
      // 使用新的action来更新Redux状态为来电状态
      // 被叫方 isInitiator 为 false
      dispatchFn(actions.call.receiveIncomingCall(data.callId, data.callerId, data.callerId, data.roomId, false));
    },
    callAccepted: (data) => {
      // 对方接听了我的呼叫
      dispatchFn(actions.call.callActive(data.callId));
    },
    callRejected: (data) => {
      // 对方拒绝了呼叫
      dispatchFn(actions.call.callFailed(data.callId, data.reason || '被对方拒绝'));
    },
    callEnded: (data) => {
      // 通话结束
      dispatchFn(actions.call.endCall(data.callId));
    },
    callBusy: (data) => {
      // 对方忙碌
      dispatchFn(actions.call.callFailed(data.callId, '对方正忙'));
    },
    callCancelled: (data) => {
      // 对方取消呼叫
      dispatchFn(actions.call.callFailed(data.callId, '呼叫被取消'));
    },
    callTimeout: (data) => {
      // 呼叫超时
      dispatchFn(actions.call.callFailed(data.callId, '呼叫超时'));
    },
    callCleaned: (data) => {
      // 通话清理完成，不需要更新状态
      console.log('Call cleaned:', data.callId);
    },
  };

  const defaultHandler = (event, payload) => {
    console.debug('Unhandled event:', event, payload);
  };

  const handlerFn = handlers[event];
  if (handlerFn !== undefined) {
    handlerFn(payload);
  } else {
    defaultHandler(event, payload);
  }
};
